import {getField, updateField} from 'vuex-map-fields';
import BatchRunHistory from '@/commonFunction/baseTableModule'

// let batch_run_history = new BatchRunHistory('/ws/table/batch_run_history/');
let batch_run_history = new BatchRunHistory('/ws/table/batch_run_history_graph/');

const state = {
    ...batch_run_history.state,
    options: {
                page: 1,
                itemsPerPage: -1,
                sortBy: ['-week_start'],
                sortDesc: [false],
                multiSort: false,
                mustSort: true,
                descending: false,

            },
    columns: [
        {text: 'Year/Week', value: 'week_start', sortable: true, divider: true, width: 120, brief: null,},
        {text: 'SMD FTE', value: 'smd_plan_fte', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'SMD tracked', value: 'smd_work_fte', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'SMD goal', value: 'smd_goal_display', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'SMD finished', value: 'smd_finish_display', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'SMD performance 1W', value: 'smd_performance', sortable: false, divider: true, brief: false,},
        {text: 'SMD performance 3W', value: 'smd_performance_3w', sortable: false, divider: true, brief: false,},
        {text: 'THT FTE', value: 'tht_plan_fte', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'THT tracked', value: 'tht_work_fte', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'THT goal', value: 'tht_goal_display', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'THT finished', value: 'tht_finish_display', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'THT performance 1W', value: 'tht_performance', sortable: false, divider: true, brief: false,},
        {text: 'THT performance 3W', value: 'tht_performance_3w', sortable: false, divider: true, brief: false,},
        {text: 'Production goal', value: 'production_goal_display', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'Production finished', value: 'production_finish_display', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'Production avg', value: 'production_avg_display', sortable: false, divider: true, width: 30, brief: false,},
        {text: 'Margin Performance 1W', value: 'production_performance', sortable: false, divider: true, brief: false,},
        {text: 'Margin Performance 3W', value: 'production_performance_3w', sortable: false, divider: true, brief: false,},
        {text: 'Margin Performance AVG', value: 'production_performance_avg', sortable: false, divider: true, brief: false,},
        {text: 'SMD', value: 'smd_hist', sortable: false, divider: true, brief: true, width: "33%"},
        {text: 'THT', value: 'tht_hist', sortable: false, divider: true, brief: true, width: "33%"},
        {text: 'Production', value: 'production_hist', sortable: false, divider: true, brief: true, width: "33%"},
    ],
};
const getters = {
    ...batch_run_history.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true || row.brief === null)
        } else {
            return state.columns.filter(row => row.brief === false || row.brief === null )
        }
    },
};
const actions = {    ...batch_run_history.actions,
};
const mutations = {
    ...batch_run_history.mutations,
};

export default {
    modules: {
        BatchRunHistoryList: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}

// const baseUrl = '/api/quote/'
// const wsURL = '/ws/table/customer/'